export const hexToRgba = (color = '#FFFFFF', opacity = 1) => {
    const bigint = parseInt(color.split('#')[1], 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return `rgba(${r},${g},${b},${opacity})`;
};
